
















import {Component, Prop, Vue} from 'vue-property-decorator'
import {BlockchainVersionCollection} from '@/model/collection/BlockchainVersionCollection'
import {FilterBlockchainVersionSchema} from '@/schema/resource/BlockchainVersion/FilterBlockchainVersionSchema'

@Component
export default class FilterBlockchainVersion extends Vue {
  @Prop({type: Object, required: true}) collection!: BlockchainVersionCollection

  schema = new FilterBlockchainVersionSchema()

  async created() {
    await this.populateFilterOptions()
  }

  async populateFilterOptions() {
    this.collection.resource = this.schema

    const promises: Array<Promise<any>> = []

    await this.$await.run('softQuery', () => Promise.all(promises))
  }

  async doFilter() {
    this.$emit('submit')
    await this.$await.run('softQuery', () => this.collection.queryAsPage())
  }
}
